import { Tabs, Tab } from "@mui/material";
import React, { memo } from "react";
import { RecordDetailsTabNames } from "@publicPortal/utils/enums";
import { useRecoilState } from "recoil";
import { buildingRegulationDetailsState } from "./BuildingRegulation";

interface BuildingRegulationTabsProps {
    recordId?: number;
}

export const PublicBuildingRegulationTabs: BuildingRegulationTabsTypes[] = [RecordDetailsTabNames.Summary, RecordDetailsTabNames.Documents];

const BuildingRegulationTabs: React.FC<BuildingRegulationTabsProps> = memo(({ recordId }) => {
    const [currentTab, setCurrentTab] = useRecoilState(buildingRegulationDetailsState);
    const tab = recordId && currentTab[recordId] ? currentTab[recordId] : RecordDetailsTabNames.Summary;

    if (recordId) {
        return (
            <Tabs
                aria-label="Building Regulation Navigation Tabs"
                variant="scrollable"
                scrollButtons="auto"
                value={tab}
                onChange={(event, newTab: BuildingRegulationTabsTypes) => setCurrentTab((prev) => ({ ...prev, [recordId ?? -1]: newTab }))}
                sx={{ margin: "2rem 0" }}
            >
                {PublicBuildingRegulationTabs.map((tabName) => {
                    return <Tab key={tabName} disableRipple label={tabName} value={tabName} />;
                })}
            </Tabs>
        );
    }
    return null;
});

export default BuildingRegulationTabs;

export const BuildingRegulationTabNames = {
    Summary: RecordDetailsTabNames.Summary,
    Documents: RecordDetailsTabNames.Documents,
} as const;

export type BuildingRegulationTabsTypes = RecordDetailsTabNames.Summary | RecordDetailsTabNames.Documents;
